import { ActionsUnion, createAction } from "../../../store/definitions";
import { IInspectionAsset, IActiveInspection, IPendingTrailerForSubmitted, InspectionActionTypes, IInspectionType } from "./types";
import { IAssetTypeGroup } from "../services/assetTypeGroupsService";

export const InspectionActions = {

    setAvailableAssetTypes: (payload: IAssetTypeGroup[]) =>
        createAction(InspectionActionTypes.SET_AVAILABLE_ASSET_TYPES, payload),

    setRegulatoryAssetTypeIds: (payload: string[]) =>
        createAction(InspectionActionTypes.SET_REGULATORY_ASSET_TYPE_IDS, payload),

    setSelectedAsset: (payload: IInspectionAsset | null) =>
        createAction(InspectionActionTypes.SET_SELECTED_ASSET, payload),

    setSelectedHistoryAsset: (payload: IInspectionAsset | null) =>
        createAction(InspectionActionTypes.SET_SELECTED_HISTORY_ASSET, payload),

    setActiveInspection: (payload: IActiveInspection) =>
        createAction(InspectionActionTypes.SET_ACTIVE_INSPECTION, payload),

    clearInspectionState: () =>
        createAction(InspectionActionTypes.CLEAR_INSPECTION_STATE),

    setPendingTrailerForSubmitted: (payload: IPendingTrailerForSubmitted) =>
        createAction(InspectionActionTypes.SET_PENDING_TRAILER_FOR_SUBMITTED, payload),

    fetchInspectionTypesRequest: () =>
        createAction(InspectionActionTypes.FETCH_INSPECTION_TYPES_REQUEST),

    fetchInspectionTypesSuccess: (payload: IInspectionType[]) =>
        createAction(InspectionActionTypes.FETCH_INSPECTION_TYPES_SUCCESS, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type InspectionActions = ActionsUnion<typeof InspectionActions>;
